/* InputPowerButtonControlComponent.js */

"use strict";

const InputBaseControlBooleanComponent = require("@gluenetworks/input_base_control").Boolean;
const Renderer = require("./InputPowerButtonControlRenderer");
const _ = require("lodash");

class InputPowerButtonControlComponent extends InputBaseControlBooleanComponent {
    /**
     * @schema.name Input PowerButton Control
     * @schema.version 2.0.0
     * @schema.package @gluenetworks/input_powerbutton_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Boolean.InputPowerButton
     * @schema.events ["Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Theme", "Label", "LabelShown", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.labelShown.name labelShown
     * @schema.configuration.labelShown.type boolean
     * @schema.configuration.labelShown.default false
     * @schema.configuration.labelShown.required false
     *
     * @schema.configuration.toolTip.name toolTip
     * @schema.configuration.toolTip.type String
     * @schema.configuration.toolTip.default ""
     * @schema.configuration.toolTip.required false
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._labelShown = _.get(configOptions, "labelShown", false);

        this._toolTip = _.get(configOptions, "toolTip", "");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._invalid = undefined;
        this._value = undefined;
        this._visible = undefined;
        this._disabled = undefined;
        this._darkTheme = undefined;
        this._theme = undefined;
        this._labelShown = undefined;
        this._label = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setLabelShown.name setLabelShown
     * @schema.methods.setLabelShown.description Sets the shown state of the label and returns an instance of the control for chainability
     * @schema.methods.setLabelShown.returns Instance of the control
     * @schema.methods.setLabelShown.parameters.newVal.name newVal
     * @schema.methods.setLabelShown.parameters.newVal.description The shown state of the label
     * @schema.methods.setLabelShown.parameters.newVal.type boolean
     */
    setLabelShown(newVal) {
        this._labelShown = newVal;
        this.emit("LabelShown", this._labelShown);
        return this;
    }
    /**
     * @schema.methods.isLabelShown.name isLabelShown
     * @schema.methods.isLabelShown.description Returns the shown state of the label
     * @schema.methods.isLabelShown.returns boolean
     */
    isLabelShown() {
        return this._labelShown;
    }
    get labelShown() {
        return this.isLabelShown();
    }
    set labelShown(newVal) {
        return this.setLabelShown(newVal);
    }

    /**
     * @schema.methods.setToolTip.name setToolTip
     * @schema.methods.setToolTip.description Sets the toolTip and returns an instance of the control for chainability
     * @schema.methods.setToolTip.returns Instance of the control
     * @schema.methods.setToolTip.parameters.newVal.name newVal
     * @schema.methods.setToolTip.parameters.newVal.description The toolTip
     * @schema.methods.setToolTip.parameters.newVal.type string
     */
    setToolTip(newVal) {
        this._toolTip = newVal;
        this.emit("ToolTip", this._toolTip);
        return this;
    }
    /**
     * @schema.methods.getToolTip.name getToolTip
     * @schema.methods.getToolTip.description Returns the toolType
     * @schema.methods.getToolTip.returns string
     */
    getToolType() {
        return this._toolTip;
    }
    get toolTip() {
        return this.getToolType();
    }
    set toolTip(newVal) {
        return this.setToolTip(newVal);
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = InputPowerButtonControlComponent;
